import { render, staticRenderFns } from "./erziyuan227.vue?vue&type=template&id=2b18ed4a&"
import script from "./erziyuan227.vue?vue&type=script&lang=js&"
export * from "./erziyuan227.vue?vue&type=script&lang=js&"
import style0 from "./erziyuan227.vue?vue&type=style&index=0&id=2b18ed4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports